var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.1665 9H22.1665M13.6665 13H17.6665M13.6665 17H15.6665M7.6665 6H7.6755M11.6665 6H11.6755M9.6665 9V21.5M3.1665 12C3.1665 7.522 3.1665 5.282 4.5575 3.891C5.9485 2.5 8.1875 2.5 12.6665 2.5C17.1445 2.5 19.3845 2.5 20.7755 3.891C22.1665 5.282 22.1665 7.521 22.1665 12C22.1665 16.478 22.1665 18.718 20.7755 20.109C19.3845 21.5 17.1455 21.5 12.6665 21.5C8.1885 21.5 5.9485 21.5 4.5575 20.109C3.1665 18.718 3.1665 16.479 3.1665 12Z",
    stroke: "#E83855",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.53a2b2c251bbfd5a20f319cf276ee6d8.svg";
export { ForwardRef as ReactComponent };